<div class="login-card">
    <div>
        <div class="login-main">
            <div class="theme-form needs-validation">
                <h4 style=" font-size: 22px;margin-bottom:20px">Log in as user</h4>
                <div *ngIf="showLogin">
                    <div class="form-group">
                        <label class="col-form-label">Enter your email address:</label>
                        <input [(ngModel)]="userName" class="form-control" type="email" required="" placeholder="name@company.com">
                        <div class="invalid-feedback">Email is required.</div>
                        <div class="invalid-feedback">Invalid Email Address.</div>
                    </div>
                    <div class="form-group">
                        <label class="col-form-label" style="">Enter your password:</label>
                        <input class="form-control" [(ngModel)]="password" type="password" placeholder="*********">
                    </div>
                    <div class="form-group">
                        <label class="col-form-label">Enter user email address:</label>
                        <input [(ngModel)]="user_userName" class="form-control" type="email" required="" placeholder="name@company.com">
                        <div class="invalid-feedback">Email is required.</div>
                        <div class="invalid-feedback">Invalid Email Address.</div>
                    </div>
                    <div class="form-group mb-0" style="margin-top:20px">
                        <button [disabled]="btnDisabled" (click)="loginAs()" class="btn btn-primary d-block w-100" type="button">Log in</button>
                    </div>
                </div>
                
            </div>
        </div>
    </div>
</div>